import styled from "styled-components"

export const StyledWeeklyOption = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 11px 25px;
  align-items: center;
  border-radius: 8px;
  background: var(--White-5, rgba(255, 255, 255, 0.049));
  cursor: default;
  line-height: 160%;

  font-weight: ${({ $active }) => ($active ? "600" : "400")};

  color: ${({ $active }) => ($active ? "#FFF" : "rgba(255, 255, 255, .8)")};

  outline: ${({ $active }) =>
    $active
      ? "1px solid #14C9C9"
      : "1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.14))"};

  @supports (-webkit-touch-callout: none) {
    outline: ${({ $active }) =>
      $active
        ? "1px solid #14C9C9"
        : "1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.14))"};
  }
`